import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Controller, useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getSources
} from "./InterestClient";
import {changeInterest} from "./interestSlice";
import {changeInterestSearch} from "./interestSearchSlice";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function InterestSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    // const {register, handleSubmit} = useForm();
    const { register, handleSubmit, control, setValue, reset } = useForm();
    const [initialMarketDropdown, setInitialMarketDropdown] = useState([]);
    const [selectedIsActive, setSelectedIsActive] = useState(null);
     const [sourceDropdown, setSourceDropdown] = useState([]);
    const [selectedSource, setSelectedSource] = useState(null);
    const [interestValue, setInterestValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [interests, setInterests] = useState([]);

    const handleClearClick = () => {
        setInterestValue("");
    };



    const fetchSources = () =>
        getSources()

            .then(data => {
                console.log("Production Types");
                console.log(data);
                console.log("Production Types with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setSourceDropdown(data);
            })


    useEffect(() => {
        console.log("This is for the dropdowns...");
        fetchSources();
    }, []);

    const [isActiveDropdown, setIsActiveDropdown] = useState("");

    const options = ["Yes", "No", ""];

    // const IsActiveDropdown = ({ options = ['', 'Yes', 'No'] }) => {
    //
    //     return (
    //


            //
            // <FormControl variant="filled" sx={{ pr: 5, minWidth: 200 }}>
            //     <InputLabel id="isActive-label">Active</InputLabel>
            //
            //     <Select
            //         {...register('isActive', { required: false })}
            //         labelId="isActive-label"
            //         id="isActive"
            //         label="Active"
            //         value={selectedIsActive}
            //         onChange={(e) => {
            //             setSelectedIsActive(e.target.value);
            //         }}
            //         sx={{ width: 150 }}
            //     >
            //         {options.map((opt, i) => (
            //             <MenuItem key={i} value={opt}>
            //                 {opt === '' ? '(None)' : opt}
            //             </MenuItem>
            //         ))}
            //     </Select>
            //
            // </FormControl>
    //     );
    // };
    // const IsActiveDropdown = ({ options = ['', 'Yes', 'No'] }) => {
    //     const [isActive, setIsActive] = useState('');
    //
    //     return (
    //         <FormControl variant="filled" sx={{ pr: 5, minWidth: 200 }}>
    //             <InputLabel id="isActive-label">Active</InputLabel>
    //             <Select
    //                 labelId="isActive-label"
    //                 id="isActive"
    //                 label="Active"
    //                 value={isActive}
    //                 onChange={(e) => setIsActive(e.target.value)}
    //                 sx={{ width: 150 }}
    //             >
    //                 {options.map((opt, i) => (
    //                     <MenuItem key={i} value={opt}>
    //                         {opt === '' ? '(None)' : opt}
    //                     </MenuItem>
    //                 ))}
    //             </Select>
    //         </FormControl>
    //     );
    // };
    // export default IsActiveDropdown;


    // export default IsActiveDropdown;

    const IsActiveDropdown = ({
                                  options = ['', 'Yes', 'No'],
                                  value,
                                  onChange
                              }) => {

        return (

            <FormControl
                variant="filled"
                sx={{ pr: 5, minWidth: 200 }}
            >

                <InputLabel id="isActive-label">
                    Active
                </InputLabel>

                <Select
                    labelId="isActive-label"
                    id="isActive"
                    label="Active"
                    value={value || ''}
                    onChange={onChange}
                    sx={{ width: 150 }}
                    variant="filled"
                >

                    {options.map((opt, i) => (

                        <MenuItem
                            key={i}
                            value={opt}
                        >

                            {opt === '' ? '(None)' : opt}

                        </MenuItem>

                    ))}

                </Select>

            </FormControl>
        );
    };

    function onSubmit(data) {
        console.log("here's my interest search data before I submit it ")
        console.log({data});
        dispatchData(changeInterestSearch({
            // searchData: data
            idFrom: data.idFrom,
            idTo: data.idTo,
            externalIdFrom: data.externalIdFrom,
            externalIdTo: data.externalIdTo,
            rateDateFrom: data.rateDateFrom,
            rateDateTo: data.rateDateTo,
            source: data.source,
            isActive: data.isActive
        }));
        dispatchData(changeInterest({
            interestGridRefresh: true
        }));
    };


    const handleSourceChange = (sourceEvent) => {
        setSelectedSource(sourceEvent.target.value);
        console.log("This is for the selected Source");
        console.log(sourceEvent.target.value);
    };

    const handleClear = () => {

        reset({
            idFrom: '',
            idTo: '',
            externalIdFrom: '',
            externalIdTo: '',
            rateDateFrom: '',
            rateDateTo: '',
            source: '',
            isActive: ''
        });

        setSelectedSource('');
        setSelectedIsActive('');
        setInterestValue('');
        setGuildValue('');
        setR2mValue('');
        setInterests([]);

        gridClear()
    };

    const handleIsActiveChange = (isActiveEvent) => {
        setSelectedIsActive(isActiveEvent.target.value);
        console.log("This is for the selected Is Active");
        console.log(isActiveEvent.target.value);
    };

    const selectR2mRef = useRef();

    const onClear = () => {
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 220, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('idFrom', { required: false })}
                               id="idFrom"   name="idFrom"  label="ID From" aria-describedby="idFrom_entry"
                               sx={{ width: 160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('idTo', { required: false })}
                               id="idTo"   name="idTo"  label="ID To" aria-describedby="idTo_entry"
                               sx={{ width: 160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalIdFrom', { required: false })}
                               id="externalIdFrom"   name="externalIdFrom"  label="External ID From" aria-describedby="externalIdFrom_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalIdTo', { required: false })}
                               id="externalIdTo"   name="externalIdTo"  label="External ID To" aria-describedby="externalIdTo_entry"
                               sx={{ width: 180, pr: 5 }} />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('externalId', { required: false })}*/}
                    {/*           id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    <FormDatePicker
                        name="rateDateFrom"
                        label="Rate Date From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="rateDateTo"
                        label="Rate Date To"
                        control={control}
                        width={200}
                    />
                {/*    <TextField variant="filled"*/}
                {/*               {...register('rateDateFrom', { required: false })}*/}
                {/*               id="rateDateFrom"   name="rateDateFrom"  label="Rate Date From" aria-describedby="rateDateFrom_entry"*/}
                {/*               sx={{ width: 180, pr: 5 }} />*/}
                {/*    <TextField variant="filled"*/}
                {/*               {...register('rateDateTo', { required: false })}*/}
                {/*               id="rateDateTo"   name="rateDateTo"  label="Rate Date To" aria-describedby="rateDateTo_entry"*/}
                {/*               sx={{ width: 180, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="source">Source</InputLabel>
                        {/*<Select*/}
                        {/*    {...register('source', { required: false })}*/}
                        {/*    labelId="demo-simple-select-filled-source"*/}
                        {/*    id="source"*/}
                        {/*    FreeSolo={true}*/}
                        {/*    variant="filled"*/}
                        {/*    label="source"*/}
                        {/*    onChange={handleSourceChange}*/}
                        {/*    sx={{ width: 200}}*/}
                        {/*>*/}
                        <Select
                            {...register('source', { required: false })}
                            labelId="demo-simple-select-filled-source"
                            id="source"
                            FreeSolo={true}
                            variant="filled"
                            label="source"
                            value={selectedSource}
                            onChange={handleSourceChange}
                            sx={{ width: 200 }}
                        >
                            {sourceDropdown.map((sourceItem) =>
                                <MenuItem  FreeSolo={true} value={sourceItem.singleField}>{sourceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <Controller
                        name="isActive"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <IsActiveDropdown
                                value={field.value}
                                onChange={field.onChange}
                            />
                        )}
                    />

                    {/*<IsActiveDropdown/>*/}
                    {/*<FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >*/}
                    {/*    <InputLabel sx={{ ml: 1}} htmlFor="isActive">Is Active</InputLabel>*/}
                    {/*    <Select*/}
                    {/*        {...register('isActive', { required: false })}*/}
                    {/*        labelId="demo-simple-select-filled-isActive"*/}
                    {/*        id="isActive"*/}
                    {/*        FreeSolo={true}*/}
                    {/*        variant="filled"*/}
                    {/*        label="isActive"*/}
                    {/*        onChange={handleIsActiveChange}*/}
                    {/*        sx={{ width: 200}}*/}
                    {/*    >*/}
                    {/*        {isActiveDropdown.map((isActiveItem) =>*/}
                    {/*            <MenuItem  FreeSolo={true} value={isActiveItem.singleField}>{isActiveItem.singleField}</MenuItem>*/}
                    {/*        )}*/}
                    {/*    </Select>*/}
                    {/*</FormControl>*/}
                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>
    )


}

